import React from 'react';
import icon from '../../../Assets/invoice (1).svg'

const RegisteredProductTable = ({ records, onViewInvoice }) => (
<div className="grid grid-cols-1 sm:grid-cols-2 gap-6 p-2">
  {records.map((record) => (
    <div
      key={record.productID}
      className="bg-white border-2 shadow-[0px_10px_60px_0px_#E2ECF980] border-dashed rounded-lg p-6 w-full max-w-5xl mx-auto"
    >
      <div className="space-y-4">
        {[{ label: "Product ID", value: record.productID },
          { label: "Product Name", value: record.productName },
          { label: "Serial No.", value: record.serialNo },
          { label: "Model No.", value: record.modelNo },
          { label: "Purchase Date", value: new Date(record.purchaseDate).toLocaleDateString() },
          { label: "Expiry Date", value: new Date(record.expiryDate).toLocaleDateString() },
        ].map((item) => (
          <div key={item.label} className="flex justify-between items-center">
            <p className="text-gray-600 text-sm font-medium whitespace-nowrap">{item.label}</p>
            <h3 className="text-base font-medium text-right">{item.value}</h3>
          </div>
        ))}

        {/* Action Section with Invoice Button */}
        <div className="flex justify-between items-center mt-4">
          <p className="text-gray-600 text-sm font-medium">Action</p>
          <button
            onClick={() => onViewInvoice(record.invoice)}
            className="flex items-center bg-[#1C50A3] text-white px-3 py-1 rounded-lg transition duration-300"
          >
            <img src={icon} alt="Invoice Icon" className="w-5 h-5 mr-2" />
            View Invoice
          </button>
        </div>
      </div>
    </div>
  ))}
</div>

);

export default RegisteredProductTable;
